import { useState, useEffect } from "react";
import { X } from "lucide-react";

/** Generic modal shell used across the Control Room */
export default function ControlModal({ open, title, onClose, onSubmit, submitLabel = "Save", children, testid }) {
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!open) return;
        const onEsc = e => { if (e.key === "Escape") onClose(); };
        window.addEventListener("keydown", onEsc);
        return () => window.removeEventListener("keydown", onEsc);
    }, [open, onClose]);

    if (!open) return null;

    const handle = async () => {
        setBusy(true);
        try { await onSubmit(); }
        finally { setBusy(false); }
    };

    return (
        <div className="fixed inset-0 z-[80] bg-black/80 flex items-start md:items-center justify-center p-3 md:p-8 overflow-y-auto"
             onClick={onClose}>
            <div className="surface w-full max-w-2xl" onClick={e => e.stopPropagation()} data-testid={testid}>
                <div className="flex items-center justify-between p-5 border-b border-white/10">
                    <div className="font-display text-xl text-white">{title}</div>
                    <button onClick={onClose} className="text-white/50 hover:text-white" aria-label="Close" data-testid={`${testid}-close`}><X size={18}/></button>
                </div>
                <div className="p-6 max-h-[70vh] overflow-y-auto space-y-4">{children}</div>
                <div className="flex justify-end gap-3 p-5 border-t border-white/10">
                    <button onClick={onClose} className="btn-outline" data-testid={`${testid}-cancel`}>Cancel</button>
                    <button onClick={handle} disabled={busy} className="btn-gold" data-testid={`${testid}-submit`}>
                        {busy ? "Saving…" : submitLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}

export function Field({ label, value, onChange, type = "text", placeholder, textarea, testid }) {
    if (textarea) return (
        <div>
            <label className="db-label">{label}</label>
            <textarea className="db-input-block db-textarea" value={value ?? ""} onChange={e => onChange(e.target.value)}
                      placeholder={placeholder} data-testid={testid} />
        </div>
    );
    return (
        <div>
            <label className="db-label">{label}</label>
            <input type={type} className="db-input-block" value={value ?? ""} onChange={e => onChange(e.target.value)}
                   placeholder={placeholder} data-testid={testid} />
        </div>
    );
}
